import React, { useState } from 'react';
import { Container } from './Container';
import { Label } from './Label';
import { ProjectDetail } from './ProjectDetail';
import { Project, projects } from './projectData';
export function Work() {
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  return <>
      <section className="border-b border-brand-gray300 py-[clamp(70px,10vw,140px)]" id="work" data-id="element-158" data-mp="3ag3se454ih5l">
        <Container data-id="element-159" data-mp="2dsh0mjizvmyh">
          <div className="mb-[clamp(40px,6vw,80px)] flex flex-wrap items-end justify-between gap-[40px]" data-id="element-160" data-mp="2dsz6m7vglfjl">
            <Label className="self-start" data-id="element-161" data-mp="2irtys0fbgggd">02 · Work</Label>
            <h2 className="max-w-[18ch] text-[clamp(2.2rem,5.6vw,5.2rem)] font-black leading-[0.95] tracking-[-0.025em]" data-id="element-162" data-mp="2mqszf8u0lr20">
              Some call them clients. We call them partners.
            </h2>
          </div>

          <div className="grid grid-cols-3 gap-[24px] max-[980px]:grid-cols-2 max-[600px]:grid-cols-1" data-id="element-163" data-mp="20txph3kce7u">
            {projects.map(project => <button key={project.slug} type="button" onClick={() => setSelectedProject(project)} className="group block w-full cursor-pointer text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-accent" aria-label={`View ${project.name} project`} data-id="element-164" data-mp="1n2lsgwfw9ujd">
                <div className="relative aspect-[4/5] overflow-hidden bg-brand-gray100" data-id="element-165" data-mp="144jcf75br7xp">
                  <img src={project.coverImage} alt={`${project.name} campaign cover featuring ${project.coverSubject}`} className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04]" data-id="element-166" data-mp="zdkqns1khhn2" />
                  <div className="absolute inset-0 bg-black/0 transition-colors duration-300 ease-out group-hover:bg-black/20" data-id="element-167" data-mp="kgjxdk3q9emh" />
                  <div className="absolute inset-x-0 bottom-0 z-10 p-6 text-white [text-shadow:0_2px_12px_rgba(0,0,0,0.45)]" data-id="element-168" data-mp="gfq9gqqabztl">
                    <span className="text-[clamp(1.6rem,3vw,2.6rem)] font-black uppercase tracking-[-0.02em]" data-id="element-169" data-mp="5vfx3l6qj8ka">
                      {project.name}
                    </span>
                  </div>
                </div>
                <div className="flex justify-between gap-4 pt-[18px]" data-id="element-170" data-mp="1rqav2dj932f">
                  <h3 className="text-[clamp(1.2rem,1.6vw,1.6rem)] font-black tracking-[-0.015em]" data-id="element-171" data-mp="1s00gouo187l">
                    {project.name}
                  </h3>
                  <span className="mt-1 text-right font-mono text-[11px] uppercase tracking-[0.12em] text-brand-gray600" data-id="element-172" data-mp="tj5tymfvs7nw">
                    {project.category}
                  </span>
                </div>
              </button>)}
          </div>
        </Container>
      </section>

      <ProjectDetail project={selectedProject} onClose={() => setSelectedProject(null)} data-id="element-173" data-mp="18fwvb1947tg5" />
    </>;
}